<template>
<div>
    <HeaderContent header="เพิ่มบทความใหม่" :img_header="header_image" link_back="contentblog" />
    <ContentAddBlogList />
</div>
</template>

<script>
import HeaderImage from '@/assets/copywriting.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import ContentAddBlogList from '@/components/menuadmin/content/contentblog/ContentAddBlogList.vue'

export default {
    name: 'contentAddBlog',
    components: {
        HeaderContent,
        ContentAddBlogList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
